import Vue from "vue";
import { getBasketPartial } from "../basket/BasketActions";

export const selectImage = ({ dispatch }, image) => {
  dispatch("SELECT_IMAGE", image);
};

export const deselectImage = ({ dispatch }, image) => {
  dispatch("DESELECT_IMAGE", image);
};

export const clearImagesList = ({ dispatch }) => {
  dispatch("CLEAR_IMAGES_LIST");
};

export const getImages = ({ dispatch }, id) => {
  dispatch("LOADING", false);
  Vue.http.get("api/v1/Images", {itemId: id}).then(function (response) {
    dispatch("IMAGES_LOADED", response.data);
  });
};

export const downloadImages = ({ dispatch }, items) => {
  var imagesToDownload = [];
  for (var i = 0; i < items.length; i++) {
    var image = { Id: items[i].Id, Resolution: items[i].SelectedResolution };
    imagesToDownload.push(image);
  }
  dispatch("DOWNLOAD", "api/v1/Images/Download", { Id: JSON.stringify(imagesToDownload) });
  dispatch("CLEAR_IMAGES_LIST");
};

export const basketImages = ({ dispatch }, items) => {
  dispatch("LOADING_BASKET");
  dispatch("START_IMAGE_PROCESSING");
  var imagesToDownload = [];
  for (var i = 0; i < items.length; i++) {
    var image = { "Id": items[i].Id, "Resolution": items[i].SelectedResolution };
    imagesToDownload.push(image);
  }
  Vue.http.post("api/v1/Images/AddImageToBasket", JSON.stringify(imagesToDownload)).then(function (response) {
    dispatch("CLEAR_IMAGES_LIST");
    getBasketPartial({dispatch});
  });
};

export const mailImages = ({ dispatch }, items) => {
  dispatch("START_IMAGE_PROCESSING");
  var imagesToDownload = [];
  for (var i = 0; i < items.length; i++) {
    var image = { "Id": items[i].Id, "Resolution": items[i].SelectedResolution };
    imagesToDownload.push(image);
  }
  Vue.http.post("api/v1/Images/SendImageByMail", JSON.stringify(imagesToDownload)).then(function (response) {
    dispatch("CLEAR_IMAGES_LIST");
    dispatch("MAIL_SENT");
  });
};



// WEBPACK FOOTER //
// ./src/views/images/ImagesActions.js